import { entities } from "sbtech-sports-data-api-client";

export class ParserHelper {
    private static _instance: ParserHelper;

    private constructor() { }

    public static get instance(): ParserHelper {
        if (!ParserHelper._instance) {
            ParserHelper._instance = new ParserHelper();
        }
        return ParserHelper._instance;
    }

    public getAdditionalScore(sportEvent: entities.SportEvent, key: string): string | undefined {
        if (!sportEvent.score || !sportEvent.score.additionalScores) {
            return undefined;
        }

        let value = sportEvent.score.additionalScores[key];
        return value == undefined ? undefined : value.toString();
    }

    public getAdditionalScores(sportEvent: entities.SportEvent, values: string[], suffix: string = ""): string[] {
        return values.map(v => this.getAdditionalScore(sportEvent, v + suffix)).filter(v => v) as string[];
    }
};